import axios from 'axios';
import { generateUrl } from '../helper';
const video = axios.create({
    baseURL: generateUrl('interview_backend'),
});

video.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem('token');
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

video.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default video;
